import { Game } from '../game.model';
import { Player } from '../player.model';

export class Configured {
  game: Game;
  player: Player;
}
